import { useCallback } from 'react'

import { useTranslation } from 'react-i18next'
import { useNavigate } from 'react-router-dom'

import ErrorImage from 'shared/images/error.png'
import { useDialogBottomSheet } from 'shared/ui/dialog-bottom-sheet/lib'
import { PopupContent } from 'shared/ui/poup-content'

export const useUmrahError = () => {
  const { t } = useTranslation()
  const navigate = useNavigate()

  const { openDialog, closeDialog } = useDialogBottomSheet()

  const goBack = useCallback(() => {
    closeDialog()
    navigate(-1)
  }, [closeDialog, navigate])

  const showError = useCallback(
    (errorMessage?: string) => {
      openDialog({
        child: (
          <PopupContent
            image={ErrorImage}
            title={t('error')}
            description={errorMessage || t('please_tey_again')}
            button={t('back')}
            onClick={goBack}
          />
        ),
        isDialog: false,
      })
    },
    [openDialog, t, goBack],
  )

  return { showError, goBack }
}
